/* eslint-disable arrow-body-style */
import _ from 'underscore';

export const getStartStyles = ({ styleOverrides }) => () => {
  return {
    start: _.extend({
      flexDirection: 'column',
      alignItems: 'center',
      position: 'absolute',
      display: 'flex',
      justifyContent: 'space-between',
      top: 20,
      left: '50%',
      color: 'white',
      transform: 'translate(-50%)',
    }, styleOverrides.startWindows),
    adContainer: _.extend({
      width: 300,
      height: 59,
      position: 'absolute',
      top: 116,
      left: 30,
      backgroundColor: '#DDDFE3',
      border: '1px solid #0078D4',
    }, styleOverrides.startWindows),
  };
};
